import Pager from './CssPage.vue';

export default {
  name: 'css-page',

  props: {
    pageSize: {
      type: [Number,String],
      default: 10
    },

    small: Boolean,

    total: [Number,String],

    pageCount: [Number,String],

    pagerCount: {
      type: [Number,String],
      validator(value) {
        return (value | 0) === value && value > 4 && value < 22 && (value % 2) === 1;
      },
      default: 7
    },

    currentPage: {
      type: [Number,String],
      default: 1
    },

    layout: {
      default: 'prev, pager, next, jumper, ->, total'
    },

    popperClass: String,

    prevText: String,

    nextText: String,

    background: Boolean,

    disabled: Boolean,

    hideOnSinglePage: Boolean
  },

  data() {
    return {
      internalCurrentPage: 1,
      internalPageSize: 0,
      lastEmittedPage: -1,
      userChangePageSize: false
    };
  },

  render(h) {
    const layout = this.layout;
    if (!layout) return null;
    if (this.hideOnSinglePage && (!this.internalPageCount || this.internalPageCount === 1)) return null;

    let template = <div class={['pagination', {
      'is-background': this.background,
      'pagination-small': this.small
    }] }></div>;
    const TEMPLATE_MAP = {
      prev: <prev></prev>,
      jumper: <jumper></jumper>,
      pager: <pager currentPage={ this.internalCurrentPage } pageCount={ this.internalPageCount } pagerCount={ this.pagerCount } on-change={ this.handleCurrentChange } disabled={ this.disabled }></pager>,
      next: <next></next>,
      sizes: <sizes></sizes>,
      slot: <slot>{ this.$slots.default ? this.$slots.default : '' }</slot>,
      total: <total></total>
    };
    const components = layout.split(',').map((item) => item.trim());
    const rightWrapper = <div class="pagination__rightwrapper"></div>;
    let haveRightWrapper = false;

    template.children = template.children || [];
    rightWrapper.children = rightWrapper.children || [];
    components.forEach(compo => {
      if (compo === '->') {
        haveRightWrapper = true;
        return;
      }

      if (!haveRightWrapper) {
        template.children.push(TEMPLATE_MAP[compo]);
      } else {
        rightWrapper.children.push(TEMPLATE_MAP[compo]);
      }
    });

    if (haveRightWrapper) {
      template.children.unshift(rightWrapper);
    }

    return template;
  },

  components: {
    Prev: {
      render(h) {
        return (
          <button
            type="button"
            class="btn-prev"
            disabled={ this.$parent.disabled || this.$parent.internalCurrentPage <= 1 }
            on-click={ this.$parent.prev }>
            {
              this.$parent.prevText
                ? <span>{ this.$parent.prevText }</span>
                : <i class="fa fa-angle-left"></i>
            }
          </button>
        );
      }
    },

    Next: {
      render(h) {
        return (
          <button
            type="button"
            class="btn-next"
            disabled={ this.$parent.disabled || this.$parent.internalCurrentPage === this.$parent.internalPageCount || this.$parent.internalPageCount === 0 }
            on-click={ this.$parent.next }>
            {
              this.$parent.nextText
                ? <span>{ this.$parent.nextText }</span>
                : <i class="fa fa-angle-right"></i>
            }
          </button>
        );
      }
    },

    Sizes: {

      render(h) {
        return (
          <span class="pagination__sizes">
            每页<input
                class="pagination__editor"
                maxlength="6"
                size="3"
                value={ this.$parent.internalPageSize }
                onKeyup={ this.keyupChange }
                onbeforepaste="clipboardData.setData('text',clipboardData.getData('text').replace(/[^\d]/g,''))"
                onChange={ this.handleChange }
            />条
          </span>
        );
      },

      methods: {
        handleChange(event) {
          var val = event.target.value;
          if (val !== this.$parent.internalPageSize) {
            this.$parent.internalPageSize = val = parseInt(val, 10);
            this.$parent.userChangePageSize = true;
            this.$parent.$emit('update:pageSize', val);
            this.$parent.$emit('size-change', val);
            this.$parent.$emit('change', {
              currentPage: this.$parent.internalCurrentPage,
              pageSize: this.$parent.internalPageSize
            });
          }
        },
        keyupChange(e){
          let theEvent = window.event || e
          let code = theEvent.keyCode || theEvent.which || theEvent.charCode
          if(code == 13){
            var val = theEvent.target.value;
            if (val !== this.$parent.internalPageSize) {
              this.$parent.internalPageSize = val = parseInt(val, 10);
              this.$parent.userChangePageSize = true;
              this.$parent.$emit('update:pageSize', val);
              this.$parent.$emit('size-change', val);
              this.$parent.$emit('change', {
                currentPage: this.$parent.internalCurrentPage,
                pageSize: this.$parent.internalPageSize
              });
              theEvent.target.blur()
            }
          }else{
            theEvent.target.value=theEvent.target.value.replace(/[^\d]/g,'')<1?1:theEvent.target.value.replace(/[^\d]/g,'')
          }
        }
      }
    },

    Jumper: {

      data() {
        return {
          userInput: null
        };
      },

      watch: {
        '$parent.internalCurrentPage'() {
          this.userInput = null;
        }
      },

      methods: {
        handleKeyup({ keyCode, target }) {
          // Chrome, Safari, Firefox triggers change event on Enter
          // Drop this method when we no longer supports IE
          if (keyCode === 13 && target.value!='') {
            this.handleChange(target.value);
          }
        },
        handleChange(event) {
          let targetPage = this.$parent.getValidCurrentPage(event.target.value);
          if(this.$parent.internalCurrentPage!=targetPage){
            this.$parent.internalCurrentPage = targetPage;
            this.$parent.emitChange();
            this.userInput = null;
          }
          event.target.value=this.$parent.internalCurrentPage
        }
      },

      render(h) {
        return (
          <span class="pagination__jump">
            第
            <input
              class="pagination__editor"
              maxlength="6"
              size="3"
              value={ this.$parent.internalCurrentPage }
              onkeyup="value=value.replace(/[^\d]/g,'')<1?'':value.replace(/[^\d]/g,'')"
              onbeforepaste="clipboardData.setData('text',clipboardData.getData('text').replace(/[^\d]/g,''))"
              onChange={ this.handleChange }
            />页
          </span>
        );
      },
      mounted(){
        let me = this;
        $(this.$el).find('input').on('keyup',function(){
          if (event.keyCode === 13) {
            this.handleChange(event);
          }
        })
      }
    },

    Total: {

      render(h) {
        return (
          typeof this.$parent.total === 'number'
            ? <span class="pagination__total">共{ this.$parent.total }条</span>
            : ''
        );
      }
    },

    Pager
  },

  methods: {
    handleCurrentChange(val) {
      this.internalCurrentPage = this.getValidCurrentPage(val);
      this.userChangePageSize = true;
      this.emitChange();
    },

    prev() {
      if (this.disabled) return;
      const newVal = this.internalCurrentPage - 1;
      this.internalCurrentPage = this.getValidCurrentPage(newVal);
      this.$emit('prev-click', this.internalCurrentPage);
      this.emitChange();
    },

    next() {
      if (this.disabled) return;
      const newVal = this.internalCurrentPage + 1;
      this.internalCurrentPage = this.getValidCurrentPage(newVal);
      this.$emit('next-click', this.internalCurrentPage);
      this.emitChange();
    },

    getValidCurrentPage(value) {
      value = parseInt(value, 10);

      const havePageCount = typeof this.internalPageCount === 'number';

      let resetValue;
      if (!havePageCount) {
        if (isNaN(value) || value < 1) resetValue = 1;
      } else {
        if (value < 1) {
          resetValue = 1;
        } else if (value > this.internalPageCount) {
          resetValue = this.internalPageCount;
        }
      }

      if (resetValue === undefined && isNaN(value)) {
        resetValue = 1;
      } else if (resetValue === 0) {
        resetValue = 1;
      }

      return resetValue === undefined ? value : resetValue;
    },

    emitChange() {
      this.$nextTick(() => {
        if (this.internalCurrentPage !== this.lastEmittedPage || this.userChangePageSize) {
          this.$emit('current-change', this.internalCurrentPage);
          this.lastEmittedPage = this.internalCurrentPage;
          this.userChangePageSize = false;
          this.$emit('change', {
            currentPage: this.internalCurrentPage,
            pageSize: this.internalPageSize,
          });
        }
      });
    }
  },

  computed: {
    internalPageCount() {
      if (typeof this.total === 'number') {
        return Math.max(1, Math.ceil(this.total / this.internalPageSize));
      } else if (typeof this.pageCount === 'number') {
        return Math.max(1, this.pageCount);
      }
      return null;
    }
  },

  watch: {
    currentPage: {
      immediate: true,
      handler(val) {
        this.internalCurrentPage = this.getValidCurrentPage(val);
      }
    },

    pageSize: {
      immediate: true,
      handler(val) {
        this.internalPageSize = isNaN(val) ? 10 : val;
      }
    },

    internalCurrentPage: {
      immediate: true,
      handler(newVal) {
        this.$emit('update:currentPage', newVal);
        this.lastEmittedPage = -1;
      }
    },

    internalPageCount(newVal) {
      /* istanbul ignore if */
      const oldPage = this.internalCurrentPage;
      if (newVal > 0 && oldPage === 0) {
        this.internalCurrentPage = 1;
      } else if (oldPage > newVal) {
        this.internalCurrentPage = newVal === 0 ? 1 : newVal;
        this.userChangePageSize && this.emitChange();
      }
      this.userChangePageSize = false;
    }
  }
};